import { FC, ReactElement } from 'react'

import { tv } from 'tailwind-variants'

import { THEME, ThemeProvider, Typography, useTheme } from '@themenu/design-system'

import { useIsTablet } from '@app/hooks/device'
import { useFooterLinks } from '@app/hooks/useFooterLinks'

export const TypographyLinks: FC = () => {
  const theme = useTheme()
  const isTablet = useIsTablet()

  const links = useFooterLinks()

  return (
    <>
      {links.map(({ id, title, path, target }) => {
        return (
          <Typography
            key={id}
            variant="callout"
            component="a"
            href={path}
            {...(target && { target })}
            color={theme.colors.content.placeholder}
            align="center"
            pr={isTablet ? 16 : 32}
          >
            {title}
          </Typography>
        )
      })}
    </>
  )
}

const legalLinkFooterContentWrapper = tv({
  base: 'flex w-full items-center justify-between',
  variants: {
    withoutPadding: {
      false: 'p-24',
      true: 'mt-24',
    },
  },
})

const LegalLinkFooterContent = ({ withoutPadding }: { withoutPadding?: boolean }): ReactElement => {
  return (
    <footer role="contentinfo" className={legalLinkFooterContentWrapper({ withoutPadding })}>
      <div className="flex w-full items-end justify-center">
        <TypographyLinks />
      </div>
    </footer>
  )
}

type LegalLinkFooterPropsType = { darkBackground?: boolean; withoutPadding?: boolean }
export const LegalLinkFooter = ({ darkBackground, withoutPadding }: LegalLinkFooterPropsType): ReactElement => {
  return (
    <>
      {darkBackground ? (
        <ThemeProvider theme={THEME.DARK} local>
          <LegalLinkFooterContent withoutPadding={withoutPadding} />
        </ThemeProvider>
      ) : (
        <LegalLinkFooterContent withoutPadding={withoutPadding} />
      )}
    </>
  )
}
